import { SelectProps } from 'antd/lib';

export const handleClickSelectAll = ({
  allKeys,
  value,
  onChange,
  onSelectChange,
}: {
  allKeys: string[],
  value?: string[],
  onChange?: SelectProps['onChange'];
  onSelectChange?: SelectProps['onChange'];
}) => () => {
  if (value?.length === allKeys.length) {
    onSelectChange?.([], []);
    return onChange?.([], []);
  }

  onSelectChange?.(allKeys, []);
  return onChange?.(allKeys, []);
};
